export default __webpack_public_path__ + "static/indoor19-fb3a4d6a133b94aaf882a198c172cc86.webp";